module.exports = __webpack_public_path__ + "static/Doja-TY-tweet-e8da7b3a43a9680cdd93543c98f395f6.mp4";